import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

export interface PropsAnimatorClassNames {
  wrapperElement: string;
}

export const getPropsAnimatorClassNames = memoizeFunction(
  (): PropsAnimatorClassNames => {
    return mergeStyleSets({
      wrapperElement: {
        display: "inline",
      },
    });
  }
);
